import React from 'react';
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Button, Box } from '@mui/material';
import { ConfirmDialogProps } from '../../types';

const ConfirmDialog: React.FC<ConfirmDialogProps> = ({ open, handleClose, handleConfirm, title, description }) => {
    return (
        <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            maxWidth="sm"
            fullWidth
            PaperProps={{
                sx: {
                    borderRadius: '12px',
                    boxShadow: '0 8px 32px rgba(0,0,0,0.12)',
                },
            }}
        >
            <DialogTitle
                id="alert-dialog-title"
                sx={{
                    textAlign: 'center',
                    pb: 2,
                    pt: 3,
                    fontSize: '1.5rem',
                    fontWeight: 700,
                    color: '#1a1a1a',
                }}
            >
                {title}
            </DialogTitle>
            <DialogContent sx={{ px: 3, pb: 2 }}>
                <Box
                    sx={{
                        p: 2,
                        backgroundColor: '#F5F5F5',
                        borderRadius: '8px',
                        border: '1px solid #E0E0E0',
                    }}
                >
                    <DialogContentText
                        id="alert-dialog-description"
                        sx={{
                            color: '#666',
                            fontSize: '1rem',
                            lineHeight: 1.6,
                            textAlign: 'center',
                            m: 0,
                        }}
                    >
                        {description}
                    </DialogContentText>
                </Box>
            </DialogContent>
            <DialogActions sx={{ px: 3, pb: 3, justifyContent: 'center', gap: 2 }}>
                <Button
                    onClick={handleClose}
                    variant="outlined"
                    sx={{
                        borderColor: '#666',
                        color: '#666',
                        px: 3,
                        py: 1,
                        fontSize: '0.95rem',
                        fontWeight: 600,
                        textTransform: 'none',
                        borderRadius: '8px',
                        borderWidth: '2px',
                        minWidth: '120px',
                        '&:hover': {
                            borderWidth: '2px',
                            borderColor: '#333',
                            backgroundColor: 'rgba(0, 0, 0, 0.04)',
                        },
                    }}
                >
                    Cancel
                </Button>
                <Button
                    onClick={handleConfirm}
                    variant="contained"
                    autoFocus
                    sx={{
                        backgroundColor: '#297AB0',
                        color: 'white',
                        px: 3,
                        py: 1,
                        fontSize: '0.95rem',
                        fontWeight: 600,
                        textTransform: 'none',
                        borderRadius: '8px',
                        minWidth: '120px',
                        '&:hover': {
                            backgroundColor: '#1f5d85',
                        },
                    }}
                >
                    Confirm
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ConfirmDialog;
